import _typeof from "@babel/runtime-corejs2/helpers/typeof";
/**
 * Inspired by
 * https://raw.githubusercontent.com/buunguyen/redux-freeze/master/src/middleware.js
 */import deepFreeze from 'deep-freeze-strict';
function isFreezable(value) {
  return value !== null && _typeof(value) === 'object';
}
function freezeStoreState(store) {
  var state = store.getState();
  if (isFreezable(state)) {
    deepFreeze(state);
  }
}

/**
 * Middleware that prevents state from being mutated anywhere in the app.
 */
export function freezeState(store) {
  return function (next) {
    return function (action) {
      freezeStoreState(store);
      try {
        next(action);
      } finally {
        freezeStoreState(store);
      }
    };
  };
}